module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "segment-panel-pages-container"
  }, [_c('div', {
    staticClass: "custom-button-navigation--left",
    on: {
      "click": function($event) {
        return _vm.dragSlide($event, -1)
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "transform": "rotate(180deg)"
    },
    attrs: {
      "viewBox": "0 0 32 32",
      "width": "20px",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "#939ea7"
    }
  }, [_c('path', {
    attrs: {
      "d": "M28.41,13.59l-10-10a2,2,0,0,0-2.82,2.82L24.17,15l-8.58,8.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,28.41,13.59Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.41,13.59l-10-10A2,2,0,0,0,3.59,6.41L12.17,15,3.59,23.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,16.41,13.59Z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "segment-panel row",
    attrs: {
      "id": "div-draggable-new"
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "ps",
    staticClass: "scroll-area",
    attrs: {
      "id": "ps-slide-wrapper-new",
      "use-both-wheel-axes": true
    },
    on: {
      "ps-scroll-x": _vm.removeSmoothing,
      "ps-scroll-y": _vm.removeSmoothing
    }
  }, [_c('div', {
    staticClass: "row__inner",
    on: {
      "mousewheel": _vm.scrollHorizontally
    }
  }, [_c('draggable', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "id": "draggable-wrapper-new",
      "move": _vm.dragSlide
    },
    on: {
      "end": _vm.reorder,
      "start": _vm.getList
    },
    model: {
      value: (_vm.list),
      callback: function($$v) {
        _vm.list = $$v
      },
      expression: "list"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "list-new-segment"
    }
  }, _vm._l((_vm.all), function(slide, index) {
    return _c('div', {
      key: 'list-new-segment' + index,
      staticClass: "card-wrapper",
      attrs: {
        "data-uid": slide.uid,
        "data-id": slide.id
      }
    }, [_c('div', {
      staticClass: "index-screen"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('custom-panel-card', {
      attrs: {
        "typecard": 'screen',
        "index": index,
        "slide": slide,
        "isSelected": slide.uid === _vm.currentSlide.uid,
        "removable": _vm.all.length > 1,
        "showVideoIntro": {}
      },
      on: {
        "selected": function($event) {
          return _vm.selectSlide(slide)
        },
        "generic": function($event) {
          return _vm.videoGenerique('intro', index)
        },
        "duplicated": function($event) {
          return _vm.handleDuplicateSlide(slide, index)
        }
      }
    })], 1)
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "folder-slide-add",
    class: {
      disabled: _vm.all.length >= _vm.permission.nb_screen_segment && _vm.getNbSreenSegment
    },
    on: {
      "click": _vm.showSlideListModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "custom-button-navigation--right",
    on: {
      "click": function($event) {
        return _vm.dragSlide($event, 1)
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 32 32",
      "width": "20px",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "#939ea7"
    }
  }, [_c('path', {
    attrs: {
      "d": "M28.41,13.59l-10-10a2,2,0,0,0-2.82,2.82L24.17,15l-8.58,8.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,28.41,13.59Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.41,13.59l-10-10A2,2,0,0,0,3.59,6.41L12.17,15,3.59,23.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,16.41,13.59Z"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39c7b468","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Panel/CustomSegmentPanelPages.vue
// module id = 828
// module chunks = 1 3